/*
 * Order metadata data types, as stored in order_metadata.data_type. Mapped to the same UI type names
 * that userMetadataOptionTypes uses, so consumers render both kinds of metadata the same way.
 */

export default {
    'EF': 'text',
    'CB': 'checkbox',
    'DD': 'select',
    'TA': 'textarea',
    'DP': 'date',
};
